'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _grid = require('constructicon/grid');

var _grid2 = _interopRequireDefault(_grid);

var _gridColumn = require('constructicon/grid-column');

var _gridColumn2 = _interopRequireDefault(_gridColumn);

var _heading = require('constructicon/heading');

var _heading2 = _interopRequireDefault(_heading);

var _image = require('constructicon/image');

var _image2 = _interopRequireDefault(_image);

var _inputSearchResult = require('constructicon/input-search-result');

var _inputSearchResult2 = _interopRequireDefault(_inputSearchResult);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CharityResult = function CharityResult(_ref) {
  var isActive = _ref.isActive,
      result = _ref.result;
  return _react2.default.createElement(
    _inputSearchResult2.default,
    { isActive: isActive, spacing: { x: 1, y: 0.25 } },
    _react2.default.createElement(
      _grid2.default,
      { align: 'center', spacing: 0.25 },
      _react2.default.createElement(
        _gridColumn2.default,
        { xs: 10 },
        _react2.default.createElement(
          _heading2.default,
          { size: 0, spacing: { y: 0.375 } },
          result.name
        )
      ),
      _react2.default.createElement(
        _gridColumn2.default,
        { xs: 2, xsAlign: 'right' },
        result.logo && _react2.default.createElement(_image2.default, {
          alt: result.name,
          maxHeight: 1.25,
          src: result.logo,
          styles: { display: 'inline-block' }
        })
      )
    )
  );
};

exports.default = CharityResult;